var _circle, _path, _path2, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "rotate(-90 24 24)",
    fill: "#28A443"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 1.36565C29.4978 0.481232 26.8051 0 24 0C21.1949 0 18.5022 0.481232 16 1.36565L16 46.6344C18.5022 47.5188 21.1949 48 24 48C26.8051 48 29.4978 47.5188 32 46.6344V1.36565Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 1.36569C41.3215 4.66039 48 13.5503 48 24C48 34.4498 41.3215 43.3397 32 46.6344V1.36569Z",
    fill: "#FF9A32"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    transform: "rotate(-90 24 24)",
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgIe;